import { render, staticRenderFns } from "./HouseRadiochannel.vue?vue&type=template&id=2c7dc30f&"
import script from "./HouseRadiochannel.vue?vue&type=script&lang=js&"
export * from "./HouseRadiochannel.vue?vue&type=script&lang=js&"
import style0 from "./HouseRadiochannel.vue?vue&type=style&index=0&id=2c7dc30f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports